import { PaintConfiguratorProps } from "@omni/types/components/props/paintConfigurator.props";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { PaintConfigurator } from "./paintConfigurator";

const PaintConfiguratorDefault = (props: PaintConfiguratorProps) => {
    const { t } = useGranite();

    return (
        <PaintConfigurator
            {...props}
            steps={[
                {
                    meta: { name: t("paintConfigurator.colorFamily") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <div>
                                <PaintConfigurator.Step.Header
                                    subTitle={t(
                                        "paintConfigurator.colorFamily.subTitle"
                                    )}
                                />
                            </div>
                            <div>
                                <PaintConfigurator.Families>
                                    <PaintConfigurator.Families.Family />
                                </PaintConfigurator.Families>
                            </div>
                        </PaintConfigurator.Step>
                    )
                },
                {
                    meta: { name: t("paintConfigurator.color") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <div>
                                <PaintConfigurator.Step.Header
                                    subTitle={t(
                                        "paintConfigurator.color.subTitle"
                                    )}
                                />
                            </div>
                            <div>
                                <PaintConfigurator.Colors>
                                    <PaintConfigurator.Colors.Color />
                                </PaintConfigurator.Colors>
                            </div>
                        </PaintConfigurator.Step>
                    )
                },
                {
                    meta: { name: t("paintConfigurator.finish") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <div>
                                <PaintConfigurator.Step.Header
                                    subTitle={t(
                                        "paintConfigurator.finish.subTitle"
                                    )}
                                />
                            </div>
                            <div>
                                <PaintConfigurator.Finishes>
                                    <PaintConfigurator.Finishes.Finish />
                                </PaintConfigurator.Finishes>
                            </div>
                        </PaintConfigurator.Step>
                    )
                },
                {
                    meta: { name: t("paintConfigurator.volume") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <div>
                                <PaintConfigurator.Step.Header
                                    subTitle={t(
                                        "paintConfigurator.volume.subTitle"
                                    )}
                                />
                            </div>
                            <div>
                                <PaintConfigurator.Volumes>
                                    <PaintConfigurator.Volumes.Volume />
                                </PaintConfigurator.Volumes>
                            </div>
                        </PaintConfigurator.Step>
                    )
                },
                {
                    meta: { name: t("paintConfigurator.product") },
                    component: (props) => (
                        <PaintConfigurator.Step {...props}>
                            <div>
                                <PaintConfigurator.Step.Header
                                    subTitle={t(
                                        "paintConfigurator.product.subTitle"
                                    )}
                                />
                            </div>
                            <div>
                                <PaintConfigurator.Products>
                                    <PaintConfigurator.Products.Product />
                                </PaintConfigurator.Products>
                            </div>
                        </PaintConfigurator.Step>
                    )
                }
            ]}
        >
            <PaintConfigurator.Navigation>
                <PaintConfigurator.Navigation.Steps>
                    <PaintConfigurator.Navigation.Steps.StepIndicator />
                </PaintConfigurator.Navigation.Steps>
            </PaintConfigurator.Navigation>
            <PaintConfigurator.Steps />
        </PaintConfigurator>
    );
};

export { PaintConfiguratorDefault };
